// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tier-wrapper[data-v-faadd8da] {\n  min-height: 630px;\n}", ""]);
// Exports
module.exports = exports;
